<div class="sg-full-height sg-full-width sg-flex-column sg-justify-center sg-items-center sg-gap-32">
  <img [src]="iconSrc" />
  <h1 class="sg-no-margin">{{ title }}</h1>
  <span class="sg-color-disabled">{{ message }}</span>
</div>
